export default __webpack_public_path__ + "static/media/blue.6ae52f02.jpg";